export type LocationCardSource = {
	id: number;
	name?: LocationName;
	slug: string;
	jobs_count?: number | string;
	categories?: {
		slug: string;
		name: string;
	}[];
};

type LocationName = {
	en: string;
	hu: string;
	ro: string;
};

export type LocationCard = {
	id: number;
	name: string;
	href: string;
	jobsCount: number;
	categories: string[];
};

export function mapLocationToCard(location: LocationCardSource, locale: string): LocationCard {
	return {
		id: location.id,
		name:
			location.name?.[locale as keyof LocationName] ||
			location.name?.ro ||
			location.name?.hu ||
			location.name?.en ||
			location.slug,
		href: `/${locale}/jobs/${location.slug.replace(/-\d+$/, "")}`,
		jobsCount: Number(location.jobs_count || 0),
		categories: (location.categories || []).map((category) => category.name),
	};
}

export function mapLocationsToCards(locations: LocationCardSource[], locale: string, limit?: number): LocationCard[] {
	const source = typeof limit === "number" ? locations.slice(0, limit) : locations;
	return source.map((location) => mapLocationToCard(location, locale));
}
